import { PRODUCTS_VIEW_TYPE } from '@/helpers';

import { MEDIA } from '@/helpers/variables';
import { mapGetters } from 'vuex';
import { storage } from '@/utils/storage';

import ProductsTogglerType from '@/components/products/ProductsBlock/ProductsTogglerType/index.vue';
import ProductsSelectSort from '@/components/products/ProductsBlock/ProductsSelectSort/index.vue';
import ProductCard from '@/components/cards/ProductCard/index.vue';
import ProductsSidebarSort from '@/components/products/ProductsBlock/ProductsSidebarSort/index.vue';
import ProductsSidebarFilters from '@/components/products/ProductsBlock/ProductsSidebarFilter/index.vue';

export default {
  name: 'ProductsBlock',
  components: { ProductsSidebarFilters, ProductsTogglerType, ProductsSidebarSort, ProductCard, ProductsSelectSort },
  props: {
    viewKey: {
      type: String,
      default: 'products_block_view'
    },
    isSmallTittle: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    sortTypeDefault: {
      type: [String, null],
      default: null
    },
    isHasFilters: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    titleTag: {
      type: String,
      default: 'h3'
    }
  },
  emits: [],
  data() {
    return {
      PRODUCTS_VIEW_TYPE,
      MEDIA,
      togglers: {
        isOpenSidebarFilters: false,
        isOpenSidebarSort: false
      },

      viewType: PRODUCTS_VIEW_TYPE.GRID
    };
  },

  created() {
    // let viewType = storage.getItem(this.viewKey);
    // if (viewType && Object.values(PRODUCTS_VIEW_TYPE).find((item) => item === viewType)) {
    //   this.viewType = viewType;
    // }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      appSize: 'app/size'
    })
  },
  methods: {
    onChangeView(type) {
      storage.setItem(this.viewKey, type);
      this.viewType = type;
    },
    onToggleSidebarFilters() {
      this.togglers.isOpenSidebarFilters = !this.togglers.isOpenSidebarFilters;
      if (this.togglers.isOpenSidebarFilters) {
        document.getElementById('html').classList.add('hide');
      } else {
        document.getElementById('html').classList.remove('hide');
      }
    },
    onToggleSidebarSort() {
      this.togglers.isOpenSidebarSort = !this.togglers.isOpenSidebarSort;
      if (this.togglers.isOpenSidebarSort) {
        document.getElementById('html').classList.add('hide');
      } else {
        document.getElementById('html').classList.remove('hide');
      }
    }
  },
  unmounted() {
    if (this.togglers.isOpenSidebarFilters || this.togglers.isOpenSidebarSort) {
      document.getElementById('html').classList.remove('hide');
    }
  }
};
